export default [{
  path: 'd-fin/gefin-mais/contas',
  name: 'contas',
  component: () => import('./index'),
  meta: {
    visible: true,
    title: 'Contas',
    order: '01',
    breadcrumb: [
      { name: 'Home', link: 'home' },
      { name: 'GEFIN', link: 'gefin' },
      { name: 'Mais', link: 'gefin-mais' },
      { name: 'Contas' }
    ]
  }
}]
